@import 'node_modules/@gaiads/telia-react-component-library/build/styles/colors';
@import '../../breakpoints';
@import '../../fonts';

.siteLinks {
  &_siteLink {
    border-bottom: solid 3px transparent !important;

    @include from('md') {
      border-bottom: solid 2px transparent !important;
    }

    .siteLinks__forceDesktop & {
      border-bottom: solid 2px transparent !important;
    }

    &__active {
      border-bottom: solid 3px color(purple500) !important;

      @include from('md') {
        border-bottom: solid 2px color(purple500) !important;
      }

      .siteLinks__forceDesktop & {
        border-bottom: solid 2px color(purple500) !important;
      }
    }
  }

  &_link {
    @include helvetica();
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 500;
    font-size: 12px;
    line-height: 42px;

    &:focus {
      outline-offset: 5px;
      outline: solid 4px color(blue500);
    }

    @include from('md') {
      line-height: 23px;
      font-size: 11px;
    }

    .siteLinks__forceDesktop & {
      line-height: 23px;
      font-size: 11px;
    }
  }
}
